import { createReactContextStore } from 'src/researcher/context/store';
import { ActiveDialogState, ActiveDialogOnPageEnum } from './dialog.types';

enum DialogActionName {
  LaunchDialog = 'rshr/system/dialog/launch_dialog',
  CloseDialog = 'rshr/system/dialog/close_dialog',
}

interface LaunchDialogAction {
  type: DialogActionName.LaunchDialog;
  payload: ActiveDialogState;
}

interface CloseDialogAction {
  type: DialogActionName.CloseDialog;
}

type ActiveDialogAction = LaunchDialogAction | CloseDialogAction;

export const InitState: ActiveDialogState = {
  dialog: ActiveDialogOnPageEnum.NO_DIALOG,
  props: {},
};

function activeDialogReducer(
  state: ActiveDialogState,
  action: ActiveDialogAction
): ActiveDialogState {
  switch (action.type) {
    case DialogActionName.LaunchDialog:
      return action.payload;
    case DialogActionName.CloseDialog:
      return InitState;
    default:
      return state;
  }
}

const { Provider, useState, useDispatch, useStore } = createReactContextStore<
  ActiveDialogState,
  ActiveDialogAction
>('ActiveDialog', activeDialogReducer);

export const useDialogDispatch = useDispatch;
export const useDialogState = useState;
export const useDialog = useStore;
export const DialogProvider = Provider;

export const launchDialogAction = (
  dialog: ActiveDialogOnPageEnum,
  props: ActiveDialogState['props'] = null
): LaunchDialogAction => ({
  type: DialogActionName.LaunchDialog,
  payload: {
    dialog,
    props,
  },
});

export const closeDialogAction = (): CloseDialogAction => ({
  type: DialogActionName.CloseDialog,
});
